import { JSX } from 'react'

/**
 * The payment-source field's empty state, shared by the disabled pre-fill
 * placeholder and the populated select. Two lines, sized to match
 * PaymentSourceRow's TokenDisplay text block (`size="small" layout="two-line"`:
 * a `text-sm`/`h-5` symbol row over a `text-xs`/`h-3` secondary row), so the
 * trigger keeps one height from an empty form through to a chosen source and
 * the rest of the form never shifts.
 */
export const PaymentSourcePlaceholder = (): JSX.Element => (
  <span className="flex w-full flex-col items-start justify-center gap-0.5">
    <span className="flex h-5 items-center truncate text-sm leading-5">
      Select a token to sell
    </span>
    <span className="flex h-3 items-center truncate text-xs leading-4">
      Balance available per network
    </span>
  </span>
)
